// AS CARTILHAS, O ÚNICO DESTINO FORA DA PLATAFORMA.
//
// São as seis cartilhas de uso, para ler na tela ou baixar em PDF, publicadas num site próprio
// (repositório `cartilhas-hqlab`) porque também circulam sozinhas — o link vai na bio do
// Instagram. O cabeçalho (`nav.tsx`) e o rodapé (`rodape.tsx`) apontam para cá, e o endereço mora
// num lugar só: se o site mudar de endereço, a troca é nesta linha.
//
// Mora num arquivo à parte, e não dentro do `nav.tsx`, para o rodapé não importar o menu inteiro —
// e com ele o Firebase — só para ler uma URL.

export const CARTILHAS = {
  rotulo: "Cartilhas",
  para: "https://cartilhas-hqlab.vercel.app/",
};
